module.exports = __webpack_public_path__ + "9cdc51bfcd6c3b7e9555d689f7b12c79.png";